import { useParams, Navigate } from "react-router-dom";
import DetailTemplate from "../components/DetailTemplate";
import { medicalConditionSchema } from "../seo/schemas";
import { DISEASE_CONTENT } from "../data/diseaseContent";

export default function DiseaseDetail() {
  const { slug } = useParams();
  const data = DISEASE_CONTENT[slug];
  if (!data) return <Navigate to="/diseases" replace />;

  return (
    <DetailTemplate
      kind="Condition"
      title={data.title}
      subtitle={data.subtitle}
      breadcrumb={[
        { label: "Conditions", to: "/diseases" },
        { label: data.shortTitle },
      ]}
      sections={data.sections}
      faq={data.faq}
      related={data.related}
      seo={{
        title: data.seoTitle,
        description: data.seoDescription,
        canonical: `/diseases/${slug}`,
        extraSchemas: data.schema ? [medicalConditionSchema(data.schema)] : [],
      }}
    />
  );
}
